exports.lang = {
    "kr": "ja",
    "아프리카TV | 투표" : "AfreecaTV  | 投票",
    "투표" : "投票",
    "투표 등록" : "投票登録",
    "투표 수정" : "投票修正",
    "투표 등록 및 수정" : "投票登録及び修正",
    "종류" : "種類",
    "기본형" : "基本形",
    "1:1 투표" : "1:1 投票",
    "제목" : "タイトル",
    "투표 제목을 입력해주세요." : "投票タイトルを入力してください。",
    "항목을 입력해주세요." : "項目を入力してください。",
    "기간" : "期間",
    "투표 종료일" : "投票終了日",
    "종료일" : "終了日",
    "설정" : "設定",
    "복수 선택 허용" : "複数選択可能",
    "결과 미리보기 허용" : "投票結果プレビュー可能",
    "체크 박스를 해제하시면 투표에 참여하기 전 또는 투표가 종료될 때까지 모든 참여자가 투표 결과를 확인할 수 없습니다." : "チェックボックスを解除すると投票参加前または投票終了するまで全ての参加者が投票結果を確認できません。",
    "수정" : "修正",
    "닫기" : "閉じる",
    "삭제" : "削除",
    "등록" : "登録",
    "투표 항목을 입력해주세요." : "投票項目を入力してください。",
    "투표 항목은 최소 2개 이상 등록해야 합니다." : "投票項目は最低2個以上登録してください。",
    "투표는 최대 3개까지 등록할 수 있습니다." : "投票は最大3個まで登録できます。",
    "투표 항목은 최대 10개까지 만들 수 있습니다." : "投票項目は最大10個まで作ることができます。",
    "투표 제목은 최대 30자까지 입력할 수 있습니다." : "投票タイトルは最大30字まで入力できます。",
    "투표 항목은 최대 10자까지 입력할 수 있습니다." : "投票項目は最大10字まで入力できます。",
    "올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요." : "正しいファイル形式ではありません。ファイル拡張子がJPG, GIFであることを確認してください。",
    "파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다." : "ファイル容量が10MBを超過し登録できません。",
    "선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요." : "選択したGIFファイルの容量が200KBを超過し、登録できません。ファイルの容量を再度ご確認ください。",
    "투표 기간을 설정해주세요." : "投票期間を設定してください。",
    "오늘보다 이전 날짜 또는 시간은 설정할 수 없습니다." : "今日より前の日時は設定できません。",
    "입력하신 내용이 모두 초기화됩니다. 투표 형식을 변경하시겠습니까?" : "入力した内容が全て初期化されます。投票形式を変更しますか？",
    "투표가 수정되었습니다." : "投票が修正されました。",
    "투표를 삭제하시겠습니까?" : "投票を削除しますか？",
    "해당 투표 항목을 삭제하시겠습니까?" : "該当投票項目を削除しますか？",
    "투표하기" : "投票する",
    "결과 미리보기" : "結果プレビュー",
    "다시 투표하기" : "もう一度投票する",
    "전체 참여자" : "全体参加者",
    "명" : "",
    "투표하러 가기" : "投票に行く",
    "현재시간 이후를 선택해주세요." : "現在の時刻以降を選択してください。",
    "투표 종료일을 3개월 이내로 선택해주세요." : "投票終了日を3ヶ月以内で選択してください",
    "투표가 등록되었습니다." : "投票を登録しました。",
    "투표를 등록한 유저가 삭제한 투표입니다." : "投票を登録したユーザーが削除した投票です。",
    "다른 투표에 참여해주세요." : "他の投票に参加してください。",
    "투표에 참여 완료되었습니다." : "投票の参加が完了しました。",
    "투표 종료" : "投票終了",
    "투표를 종료하시겠습니까?" : "投票を終了しますか？",
    "항목 추가" : "項目追加",
    "취소" : "キャンセル",
    "시" : "時",
    "분" : "分",
    "이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다.": "画像1:1投票登録の際は、投票画像を全て添付し登録してください。",
    "무승부" : "引き分け",
    "무승부 항목 추가" : "引き分け追加",
}